export const pathsWithIssues = [
  // All results get filtered out by the time
  // user reaches "Apple made headphones"
  {
    data: [
      {
        qId: 0,
        question: "How much are you looking to spend?",
        answer: "Over $250",
      },
      {
        qId: 1,
        question: "Do you want in-ears or over-ear headphones?",
        answer: "I want over-ears.",
      },
      {
        qId: 2,
        question: "Do you want wired or wireless headphones?",
        answer: "I'm tired of cables and dongles!",
      },
      {
        qId: 3,
        question: "Do you want a microphone for calls?",
        answer: "Yes, I need one for calls.",
      },
      {
        qId: 5,
        question: "Do you plan to workout in these headphones?",
        answer: "Yes, I workout daily",
      },
    ],
    resultId: [1],
  },
  // All results get filtered out by the time
  // user reaches "Apple made headphones"
  {
    data: [
      {
        qId: 0,
        question: "How much are you looking to spend?",
        answer: "Over $250",
      },
      {
        qId: 1,
        question: "Do you want in-ears or over-ear headphones?",
        answer: "I want over-ears.",
      },
      {
        qId: 2,
        question: "Do you want wired or wireless headphones?",
        answer: "I'm tired of cables and dongles!",
      },
      {
        qId: 3,
        question: "Do you want a microphone for calls?",
        answer: "Yes, I need one for calls.",
      },
      {
        qId: 5,
        question: "Do you plan to workout in these headphones?",
        answer: "Sometimes",
      },
    ],
    resultId: [4],
  },
]
